import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["noteInput", "notePreview"];

  declare noteInputTarget: HTMLTextAreaElement;
  declare notePreviewTarget: HTMLElement;

  refresh(): void {
    const note = this.noteInputTarget.value.trim();
    this.notePreviewTarget.textContent = note ? `\n\nNote: ${note}` : "";
  }
}
